const sidebarSubnav = document.querySelector('.mobile-subnav')
const sidebarToggle = document.querySelector('.mobile-subnav > .sidebar-nav > .subnav-toggle')

if (sidebarSubnav != null) {
  sidebarToggle.addEventListener('click', function () {
    sidebarSubnav.classList.toggle('subnav-open')
  })
}
